<template>
  <UpdateSave
      :maxWidth="500"
      itemKey="TicketShare"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :updateData="updateData"
      @onUpdate="(response) => $emit('onUpdate', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <v-textarea
              v-model="ItemForm.note"
              :error-messages="errors.note"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Poznámka"
              :rows="5"
          />
        </v-col>
      </v-row>
    </template>
  </UpdateSave>
</template>

<script>
  import TicketShares from '@/services/ticket-shares'

  import UpdateSave from '@/components/_Part/_Modal/_Save/Update'

  export default {
    name: 'Update',
    props: [
      'id'
    ],
    emits: [
      'onUpdate'
    ],
    components: {
      UpdateSave
    },
    methods: {
      fetchData() {
        return TicketShares
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Upraviť podiel "' + Item.User.name + '"'
      },
      setItemForm(Item) {
        return {
          note: Item.note
        }
      },
      updateData(ItemForm) {
        return TicketShares
          .update({
            id: this.id,
            data: ItemForm
          })
      }
    }
  }
</script>
